import React from 'react'

import HeroRecipeMolecule  from '@/molecules/Heroes/HeroRecipe'

const HeroRecipe = (props) => (
  <HeroRecipeMolecule {...props} />
)

export default HeroRecipe
